import listTpl from '../templates/creatives/list.directive.html';

export default function creativeList() {
  return {
    restrict: 'E',
    template: listTpl,
    controller: 'CreativeListController',
    controllerAs: 'creativeListVm'
  };
}
